import React, { useEffect, useState } from 'react'
import Layout from '../../layout/Layout';
import { useSearchParams } from 'react-router-dom';
import Rewards from './Rewards';
import ReferralTab from './ReferralTab';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';

const RewardAndRefer = () => {

  const [searchParams, setSearchParams] = useSearchParams({ tab: "" });
  const [selectedTab, setSelectedTab] = useState(searchParams.get('tab') || (accessCheck(accessKeys?.viewRewardList) ? 1 : 2));


  const [settingData, setSettingData] = useState(null);

  const getSettingData = async () => {
    let resp = await getApi(urlApi.getSettingData);
    if (resp.responseCode === 200) {
      setSettingData(resp.data);
    } else {
      setSettingData(null);
    }
  }

  useEffect(() => {
    getSettingData();
  }, []);

  return (
    <Layout>
      <div className='flex items-center justify-between mb-1'>
        <p className='text-[17px] font-bold mb-0'>Settings</p>
      </div>
      <div className="flex items-center flex-wrap justify-center gap-3 px-2 py-1 bg-white rounded-lg max-w-fit mx-auto mb-4">
        {accessCheck(accessKeys?.viewRewardList) && <button onClick={() => { setSearchParams({ tab: 1 }, { replace: true }); setSelectedTab(1) }} className={`${selectedTab == 1 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`} >Rewards</button>}
        <button onClick={() => { setSearchParams({ tab: 2 }, { replace: true }); setSelectedTab(2) }} className={`${selectedTab == 2 ? '!bg-primary text-white' : 'bg-transparent'} text-sm font-semibold px-5 py-1 rounded-lg`}>Referrals</button>
      </div>

      {selectedTab == 1 && <Rewards settingData={settingData} />}
      {selectedTab == 2 && <ReferralTab settingData={settingData} />}

    </Layout>
  )
}

export default RewardAndRefer